import React from 'react'

const Welcome = () => {
  return (
    <div className="bg-theme border border-theme-stroke flex justify-items-center rounded-xl p-10 my-4">
        <h1 className="text-2xl text-white font-bold text-center mx-auto">
            Welcome to MuVision! 🎉<br />
            Our app is designed to help you convert your handwritten Math homework to Latex. 📝
        </h1>
    </div>
  )
}

export default Welcome